module.exports = require('./dot-prop')
